/**
 * contentText — the readable text of a settled entry's LangChain `content`.
 *
 * `content` arrives in two shapes: a plain string, or a list of content blocks
 * (`[{ type: 'text', text }, { type: 'tool_use', … }]`, plain strings allowed) —
 * the list form is what a model emits when it narrates AND calls a tool in the
 * same turn. Only the text blocks are prose; `tool_use` blocks are already folded
 * from `tool_calls[]` by `reconcile`. Pure + React-free.
 */

interface TextBlock {
  type?: unknown;
  text?: unknown;
}

function blockText(block: unknown): string {
  if (typeof block === 'string') {
    return block;
  }
  const { type, text } = (block ?? {}) as TextBlock;
  return type === 'text' && typeof text === 'string' ? text : '';
}

/** A string is returned as-is; a block list yields its text blocks joined by a
 * blank line, or `undefined` when it holds none; anything else is `undefined`. */
export function contentText(content: unknown): string | undefined {
  if (typeof content === 'string') {
    return content;
  }
  if (!Array.isArray(content)) {
    return undefined;
  }
  const text = content
    .map(blockText)
    .filter((part) => part.trim() !== '')
    .join('\n\n');
  return text === '' ? undefined : text;
}
